import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Input } from '../../shared/component/form/Input';
// import loginImage from '../../assets/images/login/loginPage.jpg';
import userIcon from '../../assets/icons/mail.png';
// import { Input1 } from '../../shared/component/form/Input';
import Button from '../../shared/component/Button';
import auth from '../../utils/api/auth';
import { CloseIcon, SuccessTickIcon } from '../../shared/component/svgIcon';
import { useRecaptcha } from '../../utils/helpers';
import BackgroundLogin from '../LoginNew/BackgroundLogin';
import loginImage from '../../assets/images/wejha_login_logo.png';

function ForgotPasswordNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { VerifyRecaptcha } = useRecaptcha();
  const [value, setValue] = useState({});
  const [disable, setDisable] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [errorMessage, setError] = useState('');
  const [resetPassword, setResetPassword] = useState(false);

  useEffect(() => {
    localStorage.removeItem('data');
    if (value.email) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [value]);

  const changeHandle = (name, changeValue) => {
    setValue({ ...value, [name]: changeValue });
  };

  const submit = async () => {
    setDisable(true);
    setButtonLoading(true);
    try {
      const recaptchaToken = await VerifyRecaptcha();
      const forgetPasswordPayload = { ...value, recaptchaToken };
      await auth.forgotPassword(forgetPasswordPayload);
      setResetPassword(true);
      setDisable(false);
      setButtonLoading(false);
      setTimeout(() => {
        setResetPassword(false);
        navigate('/login');
      }, 10000);
    } catch (error) {
      setDisable(false);
      setButtonLoading(false);
      setResetPassword(true);
      setTimeout(() => {
        setResetPassword(false);
        navigate('/login');
      }, 10000);
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);

  const videoData = [
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/weather.mp4',
      heading: t('wEATHER'),
      text: (
        t('weatherInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/template.mp4',
      heading: t('tEMPLATES'),
      text: (
        t('templatesInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/content.mp4',
      heading: t('cONTENTLAYOUT'),
      text: (
        t('contentLayoutInfo')
      ),
    },
  ];
  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videoData.length);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentIndex]);

  return (
    <>
      <BackgroundLogin />
      <div className="register-container">
        <div className="banner-wrap">
          <div className="left-content">
            <img
              src={loginImage}
              alt="Logo"
              className="brand-logo"
            // style={{
            //   alignSelf: 'flex-start',
            //   display: 'block',
            //   margin: 0,
            //   padding: 0,
            // }}
            />
            <p className="caption-text">
              {t('effortlesslyCreate')}
              <span className="highlight-green"> {t('schedules')} </span>
              {t('andManage')}
              <span className="highlight-green"> {t('signage')}.</span>
            </p>
            <div className="tv-box">
              {/* You can place an image, animation, or SVG here */}
              <video
                ref={videoRef}
                src={videoData[currentIndex].src}
                autoPlay
                muted
                playsInline
                onEnded={handleVideoEnd}
                className="video-box"
              />
            </div>
            <div className="sub-tv">
              {/* sub tv */}
            </div>
            <div className="sub-title">
              <div className="heading">{videoData[currentIndex].heading}</div>
              <div className="sub-text">
                {videoData[currentIndex].text}
              </div>
            </div>
          </div>
        </div>
        <div className="register-form-wrap">
          {/* <div className="register-form"> */}
          {/* <div className="banner-wrap">
              <img src={loginImage} className="forgot-password-banner" alt="" />
            </div> */}
          <div className="form-session">
            <div className="form forgot-login-forms">
              <div className="title-container">
                <h1 className="loginTitle">{t('forgotYourPassword')}</h1>
                <p className="loginTitle1">
                  {t('enterValidRegisterEmail')}
                </p>
                {resetPassword
                  && (
                    <div className="reset-password-message">
                      <span><SuccessTickIcon /></span>
                      <p>{t('ResetPasswordLink')} </p>
                      <span
                        role="presentation"
                        onClick={() => setResetPassword(false)}
                      >
                        <CloseIcon
                          width="20px"
                          height="20px"
                          color="#212B36"
                        />
                      </span>
                    </div>
                  )}
              </div>
              {/* {(errorMessage && !resetPassword) && <p className="text-danger">{errorMessage}</p>} */}
              <Input
                icon={userIcon}
                label={t('emailAddress')}
                type="text"
                name="email"
                value={value?.email}
                change={changeHandle}
              />
              <Button
                label={t('sendMail')}
                click={submit}
                classes={buttonLoading ? 'success-button loading-btn' : 'success-button'}
                disabled={disable}
                loading={buttonLoading}
              />
              <div className="loginButton">{t('rememberPassword')}<Link to="/login">{t('login')}</Link></div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default ForgotPasswordNew;
